import { CALL_API } from './api'
import { getBSRSToken } from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]

    if (typeof entry !== 'object') return next(action)

    let token
    const entryType = entry.types[0]
    if (entryType.startsWith("CORE") || entryType.startsWith("O365")) {
        token = getBSRSToken()
    }
    // else if (entryType.startsWith("O365")) {
    //   const { service_token } = getServiceToken()
    //   token = service_token
    // }

    // if(entryType.startsWith("CORE")){
    //   token = getBSRSToken()
    // }else if(entry.types[0].startsWith("O365")){ 
    //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
    //     const { service_token } = getServiceToken()
    //     token = service_token
    //   }
    //   else token = getAccessToken()
    // }

    if (!token) return next(action)

    // entry.headers = {
    //     ...entry.headers,
    //     "Authorization": `Bearer ${token}`
    // }
    entry.headers = {...entry.headers }
    if (token) {
        entry.headers.Authorization = `Bearer ${token}`
        entry.headers["Access-Control-Allow-Origin"] = "*"
        entry.headers["Access-Control-Allow-Methods"] = "DELETE, POST, GET, OPTIONS"
        entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
    }

    next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/setToken.js